<template>
<nav class="navbar navbar-expand-lg navbar-dark bg-dark">
  <div class="container-fluid">
    <a class="navbar-brand" href="#">bib.rupek.net</a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <a class="nav-link active" aria-current="page" href="#">Home</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#">Graph</a>
        </li>
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Tags
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
            <li><a class="dropdown-item" href="#">Action</a></li>
            <li><a class="dropdown-item" href="#">Another action</a></li>
            <li><hr class="dropdown-divider"></li>
            <li><a class="dropdown-item" href="#">Something else here</a></li>
          </ul>
        </li>
        <li class="nav-item">
          <a class="nav-link disabled" href="#" tabindex="-1" aria-disabled="true">{{ papers.length }} {{ papers.length === 1 ? 'Paper' : 'Papers' }}</a>
        </li>
      </ul>
      <form class="d-flex">
        <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search">
        <button class="btn btn-outline-success">Search</button> &nbsp;
        <button class="btn btn-success" @click.prevent="save">Save</button>&nbsp;
        <button class="btn btn-success" @click.prevent="exportData">Export</button>
      </form>
    </div>
  </div>
</nav>
</template>

<script>
export default {
    props: ['papers'],
    methods: {
        save() {
            localStorage.setItem('data', JSON.stringify(this.papers))
        },
        exportData() {
            const a = document.createElement('a')
            const file = new Blob([JSON.stringify(this.papers)], { type: 'application/json' })
            a.href = URL.createObjectURL(file)
            a.download = 'Papers.json'
            a.click()
            URL.revokeObjectURL(a.href)
        }
    }
}
</script>
